(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["drifciak-accessories"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const step = event.target.closest('.dac__step');
    if (!step) return;
    const input = step.parentElement.querySelector('input[name="quantity"]');
    input.value = Math.min(20, Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.dataset.step)));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drifciak-bundle-calc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('drifciak-bundle-calc')) {
    customElements.define('drifciak-bundle-calc', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (event) => {
          const button = event.target.closest('.dbc__qty');
          if (!button) return;
          this.querySelectorAll('.dbc__qty').forEach((b) => {
            b.classList.toggle('is-active', b === button);
            b.setAttribute('aria-pressed', b === button ? 'true' : 'false');
          });
          this.update(Number(button.dataset.qty));
        });
        this.update(1);
      }
      money(cents) {
        return (Math.max(0, cents) / 100).toFixed(2).replace('.', ',') + ' zł';
      }
      update(qty) {
        const d = this.dataset;
        const price = Number(d.price);
        const compare = Number(d.compare);
        let off = 0;
        if (Number(d.qtyB) > 0 && qty >= Number(d.qtyB)) off = Number(d.offB);
        else if (Number(d.qtyA) > 0 && qty >= Number(d.qtyA)) off = Number(d.offA);
        const base = price * qty;
        const total = Math.max(0, base - off);
        const set = (key, value) => this.querySelectorAll('[data-out="' + key + '"]').forEach((el) => {
          if (el.tagName === 'INPUT') el.value = value; else el.textContent = value;
        });
        set('regular', this.money(compare * qty));
        set('base', this.money(base));
        set('discount', off > 0 ? '−' + this.money(off) : '–');
        set('total', this.money(total));
        set('save', this.money(compare * qty - total));
        set('quantity', String(qty));
        set('count', String(qty));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drifciak-color-shop"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('.dcs__qty-btn');
    if (!button) return;
    const input = button.parentElement.querySelector('.dcs__qty-input');
    input.value = Math.min(20, Math.max(1, (parseInt(input.value, 10) || 1) + Number(button.dataset.step)));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drifciak-feature"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('drifciak-feature-form')) {
    customElements.define('drifciak-feature-form', class extends HTMLElement {
      connectedCallback() {
        const form = this.querySelector('form');
        if (!form) return;
        this.addEventListener('click', (event) => {
          const step = event.target.closest('[data-step]');
          if (!step) return;
          const input = form.querySelector('input[name="quantity"]');
          input.value = Math.min(20, Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.dataset.step)));
        });
        form.addEventListener('submit', async (event) => {
          const toggle = form.querySelector('.dfe__addon-toggle');
          if (!toggle || !toggle.checked) return;
          event.preventDefault();
          const items = [
            { id: Number(form.querySelector('input[name="id"]').value), quantity: parseInt(form.querySelector('input[name="quantity"]').value, 10) || 1 },
            { id: Number(toggle.value), quantity: 1 }
          ];
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          try {
            const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
            if (!response.ok) {
              const error = await response.json().catch(() => ({}));
              window.alert(error.description || 'Nie udało się dodać do koszyka.');
              return;
            }
            window.location.href = root + 'cart';
          } catch (error) {
            window.alert('Nie udało się dodać do koszyka.');
          }
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drifciak-gallery-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('drifciak-gallery')) {
    customElements.define('drifciak-gallery', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('.dgh__slide'));
        this.thumbs = Array.from(this.querySelectorAll('.dgh__thumb'));
        this.index = 0;
        this.addEventListener('click', (event) => {
          const step = event.target.closest('[data-step]');
          const go = event.target.closest('[data-go]');
          if (step) this.show(this.index + Number(step.dataset.step));
          if (go) this.show(Number(go.dataset.go));
        });
        let startX = null;
        this.addEventListener('touchstart', (event) => { startX = event.touches[0].clientX; }, { passive: true });
        this.addEventListener('touchend', (event) => {
          if (startX === null) return;
          const dx = event.changedTouches[0].clientX - startX;
          if (Math.abs(dx) > 40) this.show(this.index + (dx < 0 ? 1 : -1));
          startX = null;
        });
      }
      show(index) {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => slide.classList.toggle('is-active', i === this.index));
        this.thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === this.index));
      }
    });
  }
  document.addEventListener('click', (event) => {
    const step = event.target.closest('[data-qty-step]');
    if (!step) return;
    const input = step.parentElement.querySelector('input[name="quantity"]');
    input.value = Math.min(20, Math.max(1, (parseInt(input.value, 10) || 1) + Number(step.dataset.qtyStep)));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drifciak-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('drifciak-carousel')) {
    customElements.define('drifciak-carousel', class extends HTMLElement {
      connectedCallback() {
        const track = this.querySelector('[data-track]');
        this.addEventListener('click', (event) => {
          const arrow = event.target.closest('[data-dir]');
          if (!arrow || !track) return;
          const card = track.querySelector('.drv__card');
          const step = card ? card.getBoundingClientRect().width + 14 : 280;
          track.scrollBy({ left: step * Number(arrow.dataset.dir), behavior: 'smooth' });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drifciak-shop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('drifciak-shop')) {
    customElements.define('drifciak-shop', class extends HTMLElement {
      connectedCallback() {
        this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        this.tiers = [
          { qty: Number(this.dataset.tierAQty), off: Number(this.dataset.tierAOff) },
          { qty: Number(this.dataset.tierBQty), off: Number(this.dataset.tierBOff) }
        ].filter((t) => t.qty > 0).sort((a, b) => a.qty - b.qty);
        this.addEventListener('click', (event) => {
          const tab = event.target.closest('[data-tab]');
          if (tab) return this.selectTab(tab.dataset.tab);
          const add = event.target.closest('[data-add]');
          if (add) return this.change(add.dataset.add, 1);
          const step = event.target.closest('[data-step]');
          if (step) return this.change(step.closest('[data-variant]').dataset.variant, Number(step.dataset.step));
        });
        this.refresh();
      }
      money(cents) {
        return (Math.max(0, cents) / 100).toFixed(2).replace('.', ',') + ' zł';
      }
      selectTab(id) {
        this.querySelectorAll('[data-tab]').forEach((t) => { const on = t.dataset.tab === id; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
        this.querySelectorAll('[data-panel]').forEach((p) => p.classList.toggle('is-active', p.dataset.panel === id));
      }
      async request(path, body) {
        const response = await fetch(this.root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || error.message || 'Nie udało się zaktualizować koszyka.');
        }
        return response.json();
      }
      async getCart() {
        const response = await fetch(this.root + 'cart.js', { headers: { Accept: 'application/json' } });
        this.cart = await response.json();
        return this.cart;
      }
      async change(variantId, delta) {
        if (this.busy) return;
        this.busy = true;
        this.classList.add('is-busy');
        try {
          const cart = await this.getCart();
          const line = cart.items.find((item) => String(item.variant_id) === String(variantId));
          if (line) await this.request('cart/change.js', { id: line.key, quantity: Math.max(0, line.quantity + delta) });
          else if (delta > 0) await this.request('cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }] });
          await this.refresh();
        } catch (error) {
          window.alert(error.message);
        } finally {
          this.busy = false;
          this.classList.remove('is-busy');
        }
      }
      async refresh() {
        const cart = await this.getCart();
        const count = cart.item_count;
        const lines = this.querySelector('[data-lines]');
        lines.innerHTML = '';
        cart.items.forEach((item) => {
          const li = document.createElement('li');
          li.className = 'dsg__line';
          const img = item.image ? document.createElement('img') : document.createElement('span');
          if (item.image) { img.src = item.image + (item.image.includes('?') ? '&' : '?') + 'width=120'; img.alt = ''; img.width = 48; img.height = 48; } else { img.className = 'dsg__line-img'; }
          const name = document.createElement('span');
          name.className = 'dsg__line-name';
          name.textContent = item.product_has_only_default_variant ? item.product_title : item.product_title + ' – ' + item.variant_title;
          const qty = document.createElement('span');
          qty.className = 'dsg__line-qty';
          qty.textContent = '×' + item.quantity;
          li.append(img, name, qty);
          lines.append(li);
        });
        this.querySelector('[data-empty]').hidden = count > 0;
        this.querySelectorAll('[data-variant]').forEach((card) => {
          const n = cart.items.filter((i) => String(i.variant_id) === card.dataset.variant).reduce((s, i) => s + i.quantity, 0);
          card.classList.toggle('is-in-cart', n > 0);
          const add = card.querySelector('[data-add]');
          const stepper = card.querySelector('.dsg__stepper');
          if (add) add.hidden = n > 0;
          if (stepper) { stepper.hidden = n === 0; stepper.querySelector('[data-qty]').textContent = n; }
        });
        const maxQty = this.tiers.length ? this.tiers[this.tiers.length - 1].qty : 1;
        this.querySelector('[data-bar]').style.width = Math.min(100, (count / maxQty) * 100) + '%';
        this.querySelector('[data-tiers]').innerHTML = this.tiers.map((t) => '<span class="dsg__tier' + (count >= t.qty ? ' is-reached' : '') + '">od ' + t.qty + ' szt.: −' + this.money(t.off) + '</span>').join('');
        const next = this.tiers.find((t) => count < t.qty);
        let hint = '';
        if (next) hint = 'Dodaj jeszcze ' + (next.qty - count) + ' szt., a rabat wyniesie ' + this.money(next.off) + '.';
        else if (this.tiers.length) hint = 'Masz najwyższy rabat pakietowy!';
        this.querySelector('[data-hint]').textContent = hint;
        this.querySelector('[data-count]').textContent = count + ' szt.';
        this.querySelector('[data-total]').textContent = this.money(cart.total_price);
        this.querySelector('[data-original]').textContent = cart.original_total_price > cart.total_price ? this.money(cart.original_total_price) : '';
        const checkout = this.querySelector('[data-checkout]');
        if (count > 0) checkout.removeAttribute('aria-disabled'); else checkout.setAttribute('aria-disabled', 'true');
        document.querySelectorAll('cart-icon').forEach((icon) => { if (typeof icon.renderCartBubble === 'function') icon.renderCartBubble(count, false); });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
